import React, {useEffect, useState} from 'react'
import './ticket.css'
import { Link } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllCases, submitCase, updateCase } from '../../api/caseApi';
import { handleAddCase } from '../../state/caseSlice';
import moment from 'moment';
import Loader from '../../components/loader/Loader'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { handleCloseModal, handleOpenModal } from '../../state/modalSlice';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';
import profile from '../../assets/profile.png'
import { GoCommentDiscussion } from "react-icons/go";


// Create a SweetAlert2 instance with React integration
const MySwal = withReactContent(Swal);



const columns = [
    { field: 'caseId', headerName: 'Ticket ID', width: 80 },
    {
        field: 'title',
        headerName: 'Title',
        width: 150,
    },
    {
        field: 'issue',
        headerName: 'Issue',
        width: 400,
        renderCell: (param)=>(
            <div dangerouslySetInnerHTML={{__html: param?.row?.issue}}></div>
        )
    },
    {
        field: 'department',
        headerName: 'Department',
        width: 150,
    },
    {
        field: 'date',
        headerName: 'Date',
        width: 120,
        renderCell: (param)=>(
            <span>
                {moment(param.row.createdAt).format('DD MMMM YYYY')}
            </span>
        )
    },
    {
        field: 'status',
        headerName: 'Status',
        width: 100,
        renderCell: (param) => {
        return (
            <span className={`ticket__content-table_status`}>
                {param.row.status}
            </span>
        )
        }
    },
    {
        field: 'action',
        headerName: 'Action',
        width: 120,
        renderCell: (param) => (
            <Link to={`/ticket/${param?.row?._id}`}
            className='' style={{color: 'var(--main-color)'}}>
                View
            </Link>
        )
    },
];



// SUBMIT TICKET FORM
const SubmitTicket = ({user, isModal, closeModal, handleFetchCases}) => {
    const [isLoading, setIsLoading] = useState(false)
    const [selectFile, setSelectedFile] = useState()

    const {
        register,
        handleSubmit,
        formState:{errors},
        setValue,
        reset,
        control
    } = useForm({
        mode: 'onChange',
        defaultValues: isModal?.data ? {...isModal.data} : ''
    })

    const handleFormSubmit = async (data)=>{
        setIsLoading(true)
        try {
            const formData = new FormData()
            const {title, issue, department, status, dueDate } = data
            formData.append('title', title)
            formData.append('issue', issue)
            formData.append('department', department)
            formData.append('status', status)
            formData.append('date', dueDate)
            formData.append('upload', selectFile)
            const res = await submitCase(user?.token, formData)
            if(res?.success){
                handleFetchCases()
                closeModal()
                MySwal.fire({
                    icon: 'success',
                    title: res?.message,
                    showConfirmButton: false,
                    timer: 4000
                });
                reset()
            }else{
                MySwal.fire({
                    icon: 'error',
                    title: res?.message,
                    showConfirmButton: false,
                    timer: 5000
                });
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            console.log(error)
            MySwal.fire({
                icon: 'error',
                title: "There's an error processing your request, Try again",
                showConfirmButton: false,
                timer: 5000
            });
        }
    }

    return(
        <div className={`modal`} onClick={closeModal}>
            <div className='modal-container'>
                <div className="modal-content overflow" 
                onClick={(e)=>e.stopPropagation()}>
                    <div className="modal-heading">
                        <h4 className='modal-title'>Submit a Ticket</h4>
                        <button onClick={closeModal}
                        className="modal-btn">x</button>
                    </div>
                    <form className="modal-form" 
                    onSubmit={handleSubmit(handleFormSubmit)}>
                        <div className="modal-field">
                            <label htmlFor="name" className="modal-label">
                                Name:
                            </label>
                            <input type="text" name='name' 
                            className="modal-input" 
                            value={user?.firstName + ' ' + user?.lastName} 
                            readOnly/>
                        </div>
                        <div className="modal-field">
                            <label htmlFor="name" className="modal-label">
                                Title/Subject:
                            </label>
                            <input type="text" name='title' 
                            className="modal-input" 
                            {...register('title',{required: 'This field is required'})}
                            />
                            <span className='modal-form_error'>
                                {errors.title ? errors.title.message : ''}
                            </span>
                        </div>
                        <div className="modal-field">
                            <label htmlFor="issue" className="modal-label">
                                Description:
                            </label>
                            <Controller
                                name="issue"
                                control={control}
                                defaultValue=""
                                rules={{required: 'This field is required'}}
                                render={({ field }) => (
                                <ReactQuill
                                    name="issue"
                                    theme="snow"
                                    value={field.value}
                                    onChange={(content) => field.onChange(content)}
                                    style={{width:'100%'}}
                                />
                                )}
                            />
                            <span className='modal-form_error'>
                                {errors.issue ? errors.issue.message : ''}
                            </span>
                        </div>
                        <div className="modal-field">
                            <label htmlFor="department" className="modal-label">
                                To Department:
                            </label>
                            <select name="department" className="modal-input"
                            {...register('department',{required: 'This field is required'})}>
                                <option value="" selected disabled>Select a department</option>
                                <option value="Account">Account</option>
                                <option value="Admin">Admin</option>
                                <option value="Compliance">Compliance</option>
                                <option value="IT">IT</option>
                                <option value="Sales">Sales</option>
                                <option value="Social Media">Social Media</option>
                                <option value="Ticket">Ticket</option>
                                <option value="Tour">Tour</option>
                                <option value="Visa">Visa</option>
                            </select>
                            <span className='modal-form_error'>
                                {errors.department ? errors.department.message : ''}
                            </span>
                        </div>
                        <div className="modal-field">
                            <label htmlFor="status" className="modal-label">
                                Status:
                            </label>
                            <select name="status" className="modal-input"
                            {...register('status',{required: 'This field is required'})}>
                                <option value="" selected disabled>Select Status</option>
                                <option value="Open">Open</option>
                                <option value="In Progress">In Progress</option>
                                <option value="On Hold">On Hold</option>
                                <option value="Escalated">Escalated</option>
                                <option value="Resolved">Resolved</option>
                                <option value="Closed">Closed</option>
                            </select>
                            <span className='modal-form_error'>
                                {errors.status ? errors.status.message : ''}
                            </span>
                        </div>
                        <div className="modal-field">
                            <label htmlFor="name" className="modal-label">
                                Due Date:
                            </label>
                            <input type="date" name='dueDate' 
                            className="modal-input" 
                            {...register('dueDate',{required: 'This field is required'})}
                            />
                            <span className='modal-form_error'>
                                {errors.dueDate ? errors.dueDate.message : ''}
                            </span>
                        </div>
                        <div className="modal-field">
                            <label htmlFor="name" className="modal-label">
                                Attachment(Optional):
                            </label>
                            <input type="file" name='file' 
                            className="modal-input" 
                            onChange={(e)=>setSelectedFile(e.target.files[0])}
                            />
                        </div>
                        <div className="modal-field">
                            {
                                isLoading ? <Loader/> : <button type='submit' 
                                className='modal-button button'>
                                    Send
                                </button>
                            }
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

const CommentList = ({user, comments, openComment, id, handleFetchCases}) => {
    const [value, setValue] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    
    const handleUpdateStatus = async ()=>{
        if(!value){
            MySwal.fire({
                icon: 'warning',
                title: "Enter a value",
                showConfirmButton: false,
                timer: 3000
            });
        }else{
            setIsLoading(true)
            try{
                const data = {comment: value, commentUser: user?._id}
                const res = await updateCase(user?.token, id, data)
                handleFetchCases()
                setIsLoading(false)
            }catch(error){
                setIsLoading(false)
                console.log(error)
                MySwal.fire({
                    icon: 'error',
                    title: "There's an error processing your request, Try again",
                    showConfirmButton: false,
                    timer: 5000
                });
            }
        }
    }

    return(
        <div className={`tickets__card-comment__items ${
            openComment === id ? 'active': ''
        }`}>
            {/* INPUT FIELD */}
            <div className="ticket__card-comment_field">
                <input type="text" value={value}
                onChange={(e)=>setValue(e.target.value)}
                className="ticket__card-comment_input" 
                placeholder='Enter comment'/>
                <button onClick={handleUpdateStatus}
                className={`ticket__card-comments-add ${
                    isLoading ? 'active' : ''
                }`}
                disabled={isLoading}>
                    {isLoading ? 'Loading...' : 'Comment'}
                </button>
            </div>

            {/* COMMENT BOX */}
            <div className="ticket__card-comment_list">
                {
                    comments?.length > 0 && comments?.map((item, i)=>(
                        <div className="ticket__card-comment_box" key={i}>
                            <div className="ticket__card-info">
                                <img src={profile} alt="" className="ticket__card-img" />
                                <div className="ticket__card-info_div comment">
                                    <h3 className="ticket__card-name">
                                        {item?.user?.firstName + ' ' + item?.user?.lastName}
                                    </h3>
                                    <p className="ticket__card-dept">
                                        {item?.user?.department + ' ' + item?.user?.role}
                                    </p>
                                    <span className="ticket__card-dept">
                                        {moment(item?.date).format('DD MMMM YYYY')}
                                    </span>
                                </div>
                            </div>
                            <p className="ticket__card-items_description">
                                {item?.text}
                            </p>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

const Ticket = () => {
    const {user} = useSelector((state)=>state.user)
    const {cases} = useSelector((state)=>state.cases)
    const {modal} = useSelector((state)=>state.modal)
    const [value, setValue] = useState()
    const [openComment, setOpenComment] = useState('')
    const dispatch = useDispatch()
    const [filters, setFilters] = useState({
        'Open': false,
        'In Progress': false, // 'In Progress' with space
        'On Hold': false, // 'On Hold' with space
        'Escalated': false,
        'Resolved': false,
        'Closed': false,
        caseId: ''
    });
    const [currentPage, setCurrentPage] = useState(1)
    
    const openModal = () => {
        dispatch(handleOpenModal())
    }

    const closeModal = () => {
        dispatch(handleCloseModal())
    }
    
    const handleFetchCases = async ()=>{
        try {
            const res = await fetchAllCases(user?.token)
            dispatch(handleAddCase(res?.data))
        } catch (error) {
            console.log(error)
        }
    }
    
    useEffect(()=>{
        handleFetchCases()
    },[])
    
    const handleUpdateStatus = async (caseId, val)=>{
        setValue(val)
        if(val){
            try{
                const data = {status: val}
                const res = await updateCase(user?.token, caseId, data)
                MySwal.fire({
                    icon: res?.success ? 'success' : 'error',
                    title: res?.message,
                    showConfirmButton: false,
                    timer: 4000
                });
                handleFetchCases()
            }catch(error){
                console.log(error)
                MySwal.fire({
                    icon: 'error',
                    title: "There's an error processing your request, Try again",
                    showConfirmButton: false,
                    timer: 5000
                });
            }
        }
    }

    // Handle input change for caseId
    const handleCaseIdChange = (event) => {
        const { value } = event.target;
        setFilters({ ...filters, caseId: value });
    };
    
    // Handle checkbox change
     const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        setFilters({ ...filters, [name]: checked });
    };

    // Filter items based on selected checkboxes and caseId
    const filteredItems = cases?.filter(item => {
        const statusFilterApplied = Object.values(filters).some(value => value); // Check if any status filter is applied
        return (
            (!statusFilterApplied || filters[item?.status]) && // Include item if no status filter applied or item status matches filter
            (filters?.caseId === '' || item?.caseId?.toLowerCase().includes(filters?.caseId?.toLowerCase()))
        );
    });


    const itemsPerPage = 12
  const startIndex = (currentPage - 1) * itemsPerPage
  const endIndex = Math.min(startIndex + itemsPerPage, filteredItems?.length)

    const pageCase = filteredItems?.slice(startIndex, endIndex)

    const handlePagination = (val) =>{
        setCurrentPage(val)
    }

    const handleToggleComment = (val) =>{
        if(val === openComment){
            setOpenComment('')
        }else{
            setOpenComment(val)
        }
    }
    

    return (
        <section className='ticket'>

            {/* HEADING */}
            <div className="heading">
                <div className="heading__box">
                    <div className="heading-item">
                        <h3 className="heading-title">Resolution case | </h3>
                        <i class='bx bx-home heading__title-icon'></i>
                        <Link to="/" className="heading-text">
                            Home <i class='bx bx-chevron-right heading-icon'></i>
                        </Link>
                        <span className="heading-text">
                            Resolution case <i class='bx bx-chevron-right heading-icon'></i>
                        </span>
                    </div>
                    <p className="heading-text">
                        View and submit cases
                    </p>
                </div>
                <button className="ticket__content-btn button"
                onClick={openModal}>
                    Submit a Case
                </button>
            </div>

            {/* TICKET CONTAINER */}
            <div className="ticket__container">
                <div className="ticket__container__box">

                    {/* FILTER & PAGINATIONS */}
                    <div className='ticket__filter-container'>
                        <div className="ticket__filter">
                            <h2 className="ticket__filter-title">
                                Filter By:
                            </h2>
                            <div className="ticket__filter-box">
                                <label htmlFor={'Case Id'} className="ticket__filter-label">
                                    Case ID
                                    <input
                                        type={'text'}
                                        name={'caseId'}
                                        className="ticket__filter-input_search"
                                        value={filters.caseId}
                                        onChange={handleCaseIdChange}
                                    />
                                </label>
                                {Object.keys(filters).map(filter => (
                                    filter !== 'caseId' &&
                                    <label key={filter} htmlFor={filter} className="ticket__filter-label">
                                        <input
                                            type={'checkbox'}
                                            id={filter}
                                            name={filter}
                                            className="ticket__filter-input"
                                            checked={filters[filter]}
                                            onChange={handleCheckboxChange}
                                        />
                                        {filter}
                                    </label>
                                ))}
                            </div>
                            <h2 className="ticket__filter-title">
                                Page:
                            </h2>
                            <div className="ticket__filter-paginations">
                                {
                                    cases?.length > 0 && 
                                    [...Array(Math.ceil(filteredItems?.length / itemsPerPage)).keys()].map((pageNum)=>(
                                        <button 
                                        key={pageNum}
                                        onClick={()=>handlePagination(pageNum + 1)}
                                        className={`ticket__filter-pagination_btn ${
                                            currentPage === pageNum + 1 ? 'active' : ''
                                        }`}>
                                            {pageNum + 1}
                                        </button>
                                    ))
                                }
                            </div>
                        </div>
                    </div>

                    {/* CASE CONTENTS */}
                    <div className="ticket__content">
                        {
                            pageCase?.length > 0 ? pageCase?.map((item, i)=>(
                                <div className="ticket__cards" key={i}>

                                    {/* PROFILE */}
                                    <div className='ticket__card-profile'>
                                        {/* CASE OWNER PROFILE */}
                                        <div className="ticket__card-info">
                                            <img src={profile} alt="" className="ticket__card-img" />
                                            <div className="ticket__card-info_div">
                                                <h3 className="ticket__card-name">
                                                    {item?.user?.firstName + ' ' + item?.user?.lastName}
                                                </h3>
                                                <p className="ticket__card-dept">
                                                    {item?.user?.department + ' ' + item?.user?.role}
                                                </p>
                                                <span className="ticket__card-dept">
                                                    <b>Date Created :</b> {moment(item?.createdAt).format('DD MMMM YYYY HH:MM:ss A')}
                                                </span>
                                            </div>
                                        </div>
                                        {/* CASE STATUS */}
                                        <div className="ticket__card-status_box">
                                            <span className="ticket__card-status">
                                                STATUS: {item?.status}
                                            </span>
                                            {user?.department === item?.department && 
                                                <select name="status" value={value} 
                                                onChange={(e)=>handleUpdateStatus(item?._id, e.target.value)}
                                                className="ticket__card-status_update">
                                                    <option value="Open">Open</option>
                                                    <option value="In Progress">In Progress</option>
                                                    <option value="On Hold">On Hold</option>
                                                    <option value="Escalated">Escalated</option>
                                                    <option value="Resolved">Resolved</option>
                                                    <option value="Closed">Closed</option>
                                                </select>
                                            }
                                        </div>
                                    </div>

                                    {/* CASE INFORMATIONS */}
                                    <div className="ticket__card-items">
                                        <h4 className="ticket__card-items_title">
                                            {item?.title}
                                        </h4>
                                        <div className="ticket__card-items_heading">
                                            <span style={{textTransform: 'uppercase'}}><b>Case ID :</b> {item?.caseId}</span>
                                            <span><b>To:</b> <i>{item?.department} DEPARTMENT</i></span>
                                            <span><b>Due Date :</b> {moment(item?.date).format('DD MMMM YYYY')}</span>
                                        </div>
                                        <p className="ticket__card-items_description"
                                            dangerouslySetInnerHTML={{__html: item?.issue}}>
                                        </p>
                                        {item?.attachment && 
                                            <img src={`https://aspom-server.onrender.com/upload/${item?.attachment}`} 
                                            alt="" 
                                            className="ticket__card-items_img"/> 
                                        }
                                    </div>

                                    {/* CASE COMMENTS */}
                                    <div className="ticket__card-comments">
                                        <button onClick={()=>handleToggleComment(item?._id)}
                                        className="ticket__card-comments_btn">
                                            Comments <b>{item?.comment?.length}</b> <GoCommentDiscussion 
                                            size={20}
                                            className="ticket__card-comments_btn-icon"/>
                                        </button>
                                        <CommentList comments={item?.comment} 
                                        user={user} handleFetchCases={handleFetchCases}
                                        openComment={openComment} id={item?._id}/>
                                    </div>
                                </div>
                            )):(
                                <div className="ticket__cards">
                                    <h2 className="ticket__filter-title">
                                        You have no resolution case.
                                    </h2>
                                </div>
                            )
                        }
                    </div>

                </div>
            </div>
            {
                modal.show && <SubmitTicket 
                user={user}
                isModal={modal} 
                closeModal={closeModal}
                handleFetchCases={handleFetchCases}/>
            }
            
        </section>
    )
}

export default Ticket